import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=640f2fb1&scoped=true&lang=pug"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"
import style0 from "./Settings.vue?vue&type=style&index=0&id=640f2fb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f2fb1",
  null
  
)

export default component.exports